"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var stringify = require("json-stable-stringify");
var MockDataRequest = /** @class */function () {
  function MockDataRequest(url, options) {
    this.url = url;
    this.requestBody = stringify(options.body);
    this.mockDataOptions = options.mockData;
    this.debug = options.debug;
    this.key = this.getKey();
  }
  MockDataRequest.prototype.getKey = function () {
    var keyObject = {
      url: this.url,
      requestBody: this.requestBody
    };
    return stringify(keyObject);
  };
  MockDataRequest.prototype.fetch = function () {
    if (this.mockDataOptions.enabled) {
      if (this.debug) {
        console.info("Request MOCK DATA: " + this.key);
      }
      var _a = this.mockDataOptions.values,
        values = _a === void 0 ? [] : _a;
      for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var value = values_1[_i];
        if (stringify(value.requestBody) === this.requestBody) {
          return value.response;
        }
      }
      return this.mockDataOptions.defaultResponse;
    }
  };
  return MockDataRequest;
}();
exports.MockDataRequest = MockDataRequest;